import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBVzXXu8_NiYk7tKtAxq_gj4cAW-1Ir6Yw",
  authDomain: "landing-page-32e56.firebaseapp.com",
  databaseURL:
    "https://landing-page-32e56-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "landing-page-32e56",
  storageBucket: "landing-page-32e56.appspot.com",
  messagingSenderId: "474995939313",
  appId: "1:474995939313:web:64e47e82b44935a9a65650",
};
/*
const firebaseConfig = {
  apiKey: "AIzaSyB1CBxlsPZYmX-SlfZ3r7fFd4SHO28JyAg",
  authDomain: "personal-page-8d04d.firebaseapp.com",
  databaseURL: "https://personal-page-8d04d-default-rtdb.firebaseio.com",
  projectId: "personal-page-8d04d",
  storageBucket: "personal-page-8d04d.appspot.com",
  messagingSenderId: "490767681423",
  appId: "1:490767681423:web:9f35a6b3a764c75d5bedfa",
};*/

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
